import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box
} from '@mui/material';
import {
  dialogFormPaperSx,
  dialogFormScrollContentSx,
  dialogFormTitleSx,
  dialogFormActionsSx
} from '../utils/dialogFormLayout';

const KinkForm = ({ open, onClose, onSubmit, kink = null, isEdit = false }) => {
  const [name, setName] = useState('');
  const [instruction, setInstruction] = useState('');

  // Update form fields when kink prop changes
  useEffect(() => {
    if (kink) {
      setName(kink.name || '');
      setInstruction(kink.instruction || '');
    } else {
      setName('');
      setInstruction('');
    }
  }, [kink]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim() && instruction.trim()) {
      onSubmit({ 
        name: name.trim(), 
        instruction: instruction.trim() 
      });
      setName('');
      setInstruction('');
      onClose();
    }
  };

  const handleClose = () => {
    setName('');
    setInstruction('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: dialogFormPaperSx }}
    >
      <DialogTitle sx={dialogFormTitleSx}>
        {isEdit ? 'Edit Kink' : 'Create New Kink'}
      </DialogTitle>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          minHeight: 0,
          overflow: 'hidden'
        }}
      >
        <DialogContent sx={(theme) => dialogFormScrollContentSx(theme)}>
          <TextField
            autoFocus
            margin="dense"
            label="Kink Name"
            type="text"
            fullWidth
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Instruction"
            multiline
            minRows={6}
            maxRows={36}
            fullWidth
            variant="outlined"
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
            required
            placeholder="Enter the instruction text for this kink..."
          />
        </DialogContent>
        <DialogActions sx={dialogFormActionsSx}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" variant="contained">
            {isEdit ? 'Save' : 'Create'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default KinkForm; 